import CategoryProductCard from './CategoryProductCard'
import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { handleGetRequest } from '../../utils/api-handler.util'
import SHOP_TYPE from '../../constants/shopTypes'
import { useFilters } from '../../hooks/useFilters'

export default function CategoryProductList({ categorySlug, shopType }) {
  const endpoint = shopType === SHOP_TYPE.retail ? `/products/retail` : `/products/wholesale`

  const { renderPagination, filters } = useFilters()
  const { data: responseData } = useQuery({
    queryKey: QueryKeys.categoryProducts(categorySlug, shopType, filters.page),
    queryFn: () =>
      handleGetRequest(endpoint, {
        categorySlug,
        page: filters.page,
      }),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: !!categorySlug,
  })

  const products = responseData?.data || []
  const totalProducts = responseData?.meta?.total || 0

  return (
    <>
      <div>
        <p className="text-sm italic my-2 font-normal">{totalProducts} Product result</p>
        {products.map((product, index) => (
          <CategoryProductCard key={index} product={product} shopType={shopType} />
        ))}
      </div>

      {renderPagination(responseData?.meta)}
    </>
  )
}
